import { lighten } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    marginTop: 30,
  },
  main: {
    minHeight: 500,
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    border: '1px solid #e0e0eb',
  },
  table: {
    minWidth: 750,
    '& tr th:nth-of-type(-n+2)': {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
    },
    '& tr td:nth-of-type(-n+2)': {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
      color: '#7e7d7e',
    },
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    marginBottom: '10px',
  },
  cellOnClick: {
    '&>a': {
      color: '#4a90e2',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  searchBtn: {
    backgroundColor: '#75c31e',
  },
  chatMessages: {
    maxHeight: 350,
    overflowY: 'scroll',
  },
  title: {
    borderBottom: '1px solid rgba(0,0,0,.125)',
    padding: 0,
    margin: 0,
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 20,
  },
  row: {
    marginTop: 16,
    '& label': {
      fontWeight: 700,
    },
  },
  btnReject: {
    borderColor: '#f50057',
    backgroundColor: '#ab003c !important',
  },
  btnApprove: {
    borderColor: '#357a38',
    backgroundColor: '#4caf50 !important',
    color: '#fff',
  },
  btnPrimary: {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    color: '#fff',
  },
  error: {
    color: '#ab003c',
  },
  termination: {
    padding: '0px 20px',
    height: '100%',
    '& h3': {
      paddingBottom: 20,
    },
  },
  closeIcon: {
    padding: 8,
  },
}));

export default useStyles;
